import React from "react";
import "./Blue_border_button.css"
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function Blue_border_button({ button_text, onClick, link }) {
  return (
    <>
      <section className="blue_border_button_holder">
        <Link to={link}>
          <Button onClick={onClick} className="blue_border_button">
            {button_text}
          </Button>
        </Link>

      </section>
    </>
  );
}

export default Blue_border_button;
